import { Injectable } from '@jack-henry/frontend-utils/di';
import { TmHttpClient } from '@treasury/core/http';

@Injectable()
export class WirePaymentDetailRequests {
    constructor(private readonly http: TmHttpClient) {}

    public async fetchWireDetails(id: number) {
        return this.http.request(`wires/${id}`, {
            method: 'GET',
        });
    }

    public async updateExternallyProcessedFXWire(body: object) {
        return this.http.request(`wires/updateexternallyprocessedfxwire`, {
            method: 'POST',
            body,
        });
    }
}
